import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import CategoriesList from "./categories-list";
import PageTitle from "../../../../common/page-title/index";
import ArrowButton from "../../../../common/button-arrow";
import {getCategories} from '../../../../../actions/news'

import './styles.css'

class Categories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: ''
    }
  }

  componentWillMount() {
    this.props.dispatch(actions.reset('deep.admin_news.category'));
    this.props.dispatch({type: 'CLEAR_EDIT_NEWS_CATEGORY'});
    this.props.dispatch(getCategories());
  }

  render() {
    return (
      <Grid bsClass="container" fluid className="news">
        <PageTitle>News Categories</PageTitle>
        <Link to="/admin/news/categories/new">
          <ArrowButton color="red"
                       className="add-category"
                       submit={false}
                       arrow={false}
                       permissions={{
                         action: 'create',
                         subjectClass: 'NewsCategory',
                       }}>Add category</ArrowButton>
        </Link>

        <CategoriesList categories={this.props.categories}
                        fetching={this.props.fetching}
                        fetched={this.props.fetched}
                        onReorder={this.handleSearch}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.news.categories.categories,
    fetched:    state.news.categories.fetched,
    fetching:   state.news.categories.fetching,
  };
};

export default connect(mapStateToProps)(Categories);


// WEBPACK FOOTER //
// ./src/components/admin/news/categories/list/index.jsx